function showCookieWarning() {
  const errorElement = document.createElement('cmpr-alert-banner');
  errorElement.classList.add('hero__alert');
  errorElement.setAttribute('variant', 'error');

  const errorTextNode = document.createTextNode(
    'Diese Seite benötigt Cookies. Bitte aktiviere die Unterstützung für Cookies in Deinen Browsereinstellungen.',
  );
  errorElement.appendChild(errorTextNode);

  document.querySelector('header .container').prepend(errorElement);
  window.scrollTo(0, 0);

  return false;
}

export default () => {
  let cookiesEnabled = navigator.cookieEnabled;

  if (!cookiesEnabled) {
    document.cookie = 'cookiecheck';
    cookiesEnabled = document.cookie.indexOf('cookiecheck') !== -1;
    document.cookie = 'cookiecheck=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
  }

  return cookiesEnabled || showCookieWarning();
};
